import React, { useEffect, useState, useContext } from 'react';
import { Dialog,Backdrop, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, MenuItem,InputAdornment, CircularProgress } from '@mui/material';
import { BlobClient, BlobServiceClient } from '@azure/storage-blob';
import { deleteFromCache, saveToCache, loadTitleCache, loadFromCacheBu } from './CacheHandler';
import { nanoid } from 'nanoid';
import { ModeContext } from './ModeContext';
import { decodeBase64UTF8, encodeBase64UTF8 } from './Codec';
import { SendToCosmos,LoadToCosmos,DeleteToCosmos } from './SendToCosmos';
import { AddAPhoto } from '@mui/icons-material';

const FileDetailModal = ({open, onClose, fileData,fileDataAll,type,onUpdated}) => {

  const isEditMode = type === "edit" && fileData && fileData.raw;
//fileDataAll リストデータ全て
  const {  filebuList,setFilebuList, selectedFiles, setSelectedFiles, user,loginInfo } = useContext(ModeContext);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryValue, setCategoryValue] = useState('');
  const [tagValue, setTagValue] = useState('');
  const [filter1, setFilter1] = useState('');
  const [filter2, setFilter2] = useState('ALL_USER');
  const [filter3, setFilter3] = useState('');
  const [filter4, setFilter4] = useState('');
  const [filter5, setFilter5] = useState('');
  const [rangeValue, setRangeValue] = useState('');
  
  const [publicValue, setPublicValue] = useState('publish');
  const [viewFlag, setViewFlag] = useState('view');
  const [storedCompId, setStoredCompId] = useState('');
  const [compId, setCompId] = useState('');
  const [userId, setUserId] = useState('');

  // 公開/非公開の選択変更
  const handleChange = (event) => setPublicValue(event.target.value);
  const handleViewChange = (event) => setViewFlag(event.target.value);


    // 初期値設定
    useEffect(() => {
      setStoredCompId(localStorage.getItem('compId'));
      const comp = localStorage.getItem('compId');
      const userIdLocal = localStorage.getItem('userId');
      if (comp && userIdLocal) {
        setCompId(comp);
        setUserId(userIdLocal);
      }

    }, [fileData?.buId, setFilebuList]);

  useEffect(() => {
    if (type === "edit" && fileData?.raw) {
      setFilter1(fileData.raw.filter1 || '');
      setFilter2(fileData.raw.filter2 || 'ALL_USER');
      setFilter3(fileData.raw.filter3 || '');
      setPublicValue(fileData.raw.status || 'publish');
    } else {
      // ★ new モード時は初期化（プリセットがあれば使用）
      setFilter1(fileData?.raw?.filter1 || '');
      setFilter2('ALL_USER');
      setFilter3('');
      setPublicValue('publish');
    }
  }, [type,fileData]);

  if (typeof onClose !== 'function') {
    console.error('onClose is not function', onClose);
    return null;
  }
  if (typeof onClose !== 'function') {
    console.error('onClose is not function', onClose);
    return null;
  }

  // ファイル選択
  const handleFileChange = (event) => {
    setSelectedFiles(Array.from(event.target.files));
  };


//更新
  const handleUpdate = async () => {
    if (filter1 === ''|| filter1 === '') {
      alert('未入力の箇所があります。');
      return;
    }

    const confirm = window.confirm('この保存しますか？');
    if (!confirm) return;
    const timestamp = Date.now();

    const containerSasUrl=`${process.env.REACT_APP_BLOB_URL}/${fileData.raw.fileid || fileData.raw.id}?comp=metadata&${process.env.REACT_APP_BLOB_TOKEN}`;

    try {
      const headers = {
        "x-ms-version": "2020-10-02",
        "x-ms-date": new Date().toUTCString(),
        "x-ms-meta-uploadedBy": user,
        "x-ms-meta-user": loginInfo.userId,
        "x-ms-meta-filename": encodeBase64UTF8(fileData.raw.filename),
        "x-ms-meta-bu": loginInfo.compId,
        "x-ms-meta-filter1": encodeBase64UTF8(filter1),
        "x-ms-meta-filter2": filter2,
        "x-ms-meta-filter3": filter3,
        "x-ms-meta-filter4": loginInfo.userId,
        "x-ms-meta-filter5": 'u_doc',
        "x-ms-meta-status": publicValue,
        "x-ms-blob-type": "BlockBlob"
      };

      const res = await fetch(containerSasUrl, { method: "PUT", headers });

      if (res.ok) {
        // フラットなドキュメント形式でCosmosDBに保存（上書き）
        const payload = {
          id: fileData.raw.id,
          fileid: fileData.raw.fileid || fileData.raw.id,
          bu: loginInfo.compId,
          category: filter1,
          filename: fileData.raw.filename,
          url: fileData.raw.url,
          filter1: filter1,
          filter2: filter2,
          filter3: filter3,
          filter4: loginInfo.userId,
          filter5: 'u_doc',
          status: publicValue,
          timestamp: timestamp,
          container: "con-concierge-file"
        };
        await SendToCosmos(payload);

        if (onUpdated && typeof onUpdated === 'function') {
          try {
            onUpdated();
          } catch (error) {
            console.error('onUpdated callback error:', error);
          }
        }

        alert('保存しました。');
        onClose();
      } else {
        console.error("❌ エラーが発生:", res.statusText);
        alert('保存に失敗しました。');
      }
    } catch (error) {
      console.error('アップロードエラー:', error);
    }
  };


//新規
  const handleUpload = async () => {
    if (selectedFiles.length === 0 || filter1 === '') {
        alert('未入力の箇所があります。');
      return;
    }

    setIsLoading(true);

    const timestamp = Date.now();
    const containerSasUrl=`${process.env.REACT_APP_BLOB_URL}?${process.env.REACT_APP_BLOB_TOKEN}`;

    try {
      let metadata = {}
      const containerClient = new BlobServiceClient(containerSasUrl).getContainerClient('');

      const uploadPromises = selectedFiles.map(async (file) => {
        const uniqueId = nanoid();
        const blobName = `User/${loginInfo.compId}/${uniqueId}-${file.name}`;
        const blockBlobClient = containerClient.getBlockBlobClient(blobName);

        metadata = {
          uploadedBy: user,
          user:loginInfo.userId,
          filename: encodeBase64UTF8(file.name),
          bu:loginInfo.compId,
          filter1:encodeBase64UTF8(filter1),
          filter2:filter2,
          filter3:filter3,
          filter4:loginInfo.userId,
          filter5:'u_doc',
          status:publicValue
        };

        const result = await blockBlobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type },
          metadata: metadata,
        });

        if (result._response.status >= 200 && result._response.status < 300) {
          // フラットなドキュメント形式でCosmosDBに保存
          const payload = {
            id: uniqueId,
            fileid: blobName,
            bu: loginInfo.compId,
            category: filter1,
            filename: file.name,
            url: blockBlobClient.url,
            filter1: filter1,
            filter2: filter2,
            filter3: filter3,
            filter4: loginInfo.userId,
            filter5: 'u_doc',
            status: publicValue,
            timestamp: timestamp,
            container: "con-concierge-file"
          };
          await SendToCosmos(payload);

          if (onUpdated && typeof onUpdated === 'function') {
            try {
              onUpdated();
            } catch (error) {
              console.error('onUpdated callback error:', error);
            }
          }
        } else {
            console.warn("アップロードに問題があるかもしれません");
        }
      });

      await Promise.all(uploadPromises);
      setSelectedFiles([]);

      if (onUpdated && typeof onUpdated === 'function') {
        try {
          onUpdated();
        } catch (error) {
          console.error('onUpdated callback error:', error);
        }
      }
      
      alert('保存完了しました。');
      document.activeElement.blur();
      onClose();
      
    } catch (error) {
      console.error('アップロードエラー:', error);
    }finally {
      setIsLoading(false);
    }
  };

// 削除
  const handleDelete = async (fileData) => {
    const confirm = window.confirm('このファイルを削除しますか？');

    if (!confirm) return;
    setIsLoading(true);
    try {
      // Blob Storageから削除
      const blobPath = fileData.raw.fileid || fileData.raw.id;
      const containerSasUrl=`${process.env.REACT_APP_BLOB_URL}/${blobPath}?${process.env.REACT_APP_BLOB_TOKEN}`;
      const blobClient = new BlobClient(containerSasUrl);
      await blobClient.delete();

      // CosmosDBからフラットなドキュメントを削除
      const payload = {
        id: fileData.raw.id,
        container: "con-concierge-file"
      };
      await DeleteToCosmos(payload);

      if (onUpdated && typeof onUpdated === 'function') {
        try {
          onUpdated();
        } catch (error) {
          console.error('onUpdated callback error:', error);
        }
      }

      alert('ファイルを削除しました。');
      onClose();

    } catch (err) {
      alert('ファイルを削除に失敗しました。');
      console.error("削除エラー:", err.message);
    }finally {
      setIsLoading(false);
    }
  };


  return (
    <Dialog
      open={open}
      onClose={onClose} // ローディング中は閉じさせない
      fullWidth
      disableEscapeKeyDown={isLoading}
    >
      <DialogTitle>{"ファイル追加"}</DialogTitle>
      <DialogContent dividers>
      <Typography
        variant="body1"
        component="div"   // ★ div に変更
        sx={{ mt: 2 }}
      >
        {isEditMode && (
          <Typography variant="body2">
            <a href={fileData.raw.url} target="_blank" rel="noopener noreferrer">
              {fileData.raw.filename}
            </a>
          </Typography>
        )}
      </Typography>

        {isEditMode && (
          <Typography variant="body2" sx={{ mb: 1, color: '#888', fontSize: '0.8rem' }}>
            最終更新者: {fileData.raw.filter4 || '不明'}　／　更新日時: {fileData.raw.timestamp ? new Date(fileData.raw.timestamp).toLocaleString('ja-JP') : '不明'}
          </Typography>
        )}

        <TextField
          variant="outlined"
          fullWidth
          label="カテゴリー"
          margin="normal"
          value={filter1}
          onChange={(e) => setFilter1(e.target.value)}
          disabled={isEditMode}
        />

        <TextField
          variant="outlined"
          fullWidth
          label="閲覧対象"
          margin="normal"
          value={filter2}
          onChange={(e) => setFilter2(e.target.value)}
          select
          >
            {(loginInfo.authorityId === 'HQ' || loginInfo.authorityId === 'store') ? [
              <MenuItem key="HQ_ONLY" value="HQ_ONLY">本部のみ</MenuItem>,
              <MenuItem key="STORE_ONLY" value="STORE_ONLY">店舗のみ</MenuItem>,
              <MenuItem key="ALL_USER" value="ALL_USER">全従業員</MenuItem>
            ] : [
              <MenuItem key="MY_ONLY" value="MY_ONLY">自分のみ</MenuItem>,
              <MenuItem key="ALL_USER" value="ALL_USER">グループ全員</MenuItem>
            ]}
        </TextField>

        <TextField
          variant="outlined"
          fullWidth
          label="公開設定"
          margin="normal"
          value={publicValue}
          onChange={handleChange}
          select
        >
          <MenuItem value="publish">公開</MenuItem>
          <MenuItem value="private">非公開</MenuItem>
        </TextField>

        {type === "new" && (
          <>
            <input
              type="file"
              multiple 
              onChange={handleFileChange}
            />

            <ul>
              {selectedFiles.map((file, index) => (
                <li key={index}>{file.name}</li>
              ))}
            </ul>
          </>
        )}
      </DialogContent>

      <DialogActions>
{type === "edit" && (
  <Button
    onClick={() => handleDelete(fileData)}
    disabled={isLoading}
  >
    削除
  </Button>
)}
        <Button
onClick={() => {
  if (type === "new") {
    handleUpload();
  }
  if (type === "edit") {
    handleUpdate();
  }
}}
          color="primary" disabled={isLoading}>
          保存
        </Button>
        <Button onClick={() => {
    onClose();
  }} color="secondary" disabled={isLoading}　>
          キャンセル
        </Button>
      </DialogActions>

      {/* 保存中のローディング表示 */}
      <Backdrop open={open && isLoading} sx={{ color: "#fff", zIndex: 2000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default FileDetailModal;
